import React from 'react';
import BitaTable from '../../../../../../bitaComponents/BitaTable/BitaTable';
import styles from './preview-summary-modal.module.scss';

const SummaryTables = ({ rows, columns, updatedRows, updatedColumns, isSubmitBasket }) => {
  const isUpdatedData = updatedRows.length > 0;
  const shouldShowUpdatedData = !isSubmitBasket && isUpdatedData;
  return (
    <div>
      <div className={styles.tableSpacing} />
      <div className={styles.tableTitle}>CURRENT BASKET DETAILS</div>
      <BitaTable
        id="basket"
        search={false}
        data={rows}
        showFields={columns}
        showOnly={15}
        selectAction={() => {}}
        CustomRowComponent={({ value }) => (
          <div>
            <p className={styles.tableCellPadding}>{value}</p>
          </div>
        )}
      />
      {shouldShowUpdatedData && (
        <>
          <div className={styles.tableSpacing} />
          <div className={styles.tableTitle}>CHANGES TO BE APPLIED</div>
          <BitaTable
            id="basket"
            search={false}
            data={updatedRows}
            showFields={updatedColumns}
            showOnly={15}
            selectAction={() => {}}
            CustomRowComponent={({ value }) => (
              <div>
                <p className={styles.tableCellPadding}>{value}</p>
              </div>
            )}
          />
        </>
      )}
    </div>
  );
};

export default SummaryTables;
